// 🔧 organization_relationship_section.js
// ✅ Purpose: Reusable relationship section for the Organization Detail Panel
// ✅ Features:
// - Expand/collapse behavior
// - Uniform Bootstrap styling
// - Relationship count
// - Placeholder for future live Organization Engine data
//
// ✅ Notes:
// - Presentation only
// - Future versions will display live Events, Members, Community, etc.

import React, { useState } from "react";

const OrganizationRelationshipSection = ({
  title,
  count = 0,
  children,
}) => {

  const [expanded, setExpanded] =
    useState(false);

  return (

    <div className="card shadow-sm mb-3">

      <div
        className="card-header bg-white d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer" }}
        onClick={() =>
          setExpanded(!expanded)
        }
      >

        <div>

          <strong>

            {title}

          </strong>

          <span className="text-muted ms-2">

            ({count})

          </span>

        </div>

        <div>

          {expanded ? "▼" : "▶"}

        </div>

      </div>

      {expanded && (

        <div className="card-body">

          {children}

        </div>

      )}

    </div>

  );

};

export default OrganizationRelationshipSection;